<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Thêm mới thể loại bài viết</strong>
                    </div>
                    <b-form @submit.prevent="save">
                        <b-row>
                            <b-col>
                                <b-form-group label="Tên thể loại bài viết:"
                                              label-for="name"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="right"
                                              label-class="required">
                                    <b-form-input type="text" id="name"
                                                  class="col-6"
                                                  aria-describedby="codeFeedback"
                                                  v-model="$v.blogCategory.name.$model"
                                                  :state="$v.blogCategory.name.$dirty? !$v.blogCategory.name.$error : null">
                                    </b-form-input>
                                    <b-form-invalid-feedback id="codeFeedback">
                                        Vui lòng nhập tên thể loại bài viết
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="SeoTitle:"
                                              label-for="name"
                                              :label-cols="4"
                                              label-align="right"
                                              :horizontal="true">
                                    <b-form-textarea v-model="$v.blogCategory.seoTitle.$model"
                                                     :state=" $v.blogCategory.seoTitle.$model && $v.blogCategory.metaTitle.$dirty ? !$v.blogCategory.seoTitle.$error : null"
                                                     class="col-6" id="seoTitle" rows="3"></b-form-textarea>
                                    <b-form-invalid-feedback v-if="!$v.blogCategory.seoTitle.maxLength">
                                        Không được quá 256 ký tự !
                                    </b-form-invalid-feedback>
                                </b-form-group>

                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="MetaTitle:"
                                              label-for="name"
                                              :label-cols="4"
                                              label-align="right"
                                              :horizontal="true">
                                    <b-form-textarea v-model="$v.blogCategory.metaTitle.$model"
                                                     :state=" $v.blogCategory.metaTitle.$model && $v.blogCategory.metaTitle.$dirty ? !$v.blogCategory.metaTitle.$error : null"
                                                     class="col-6" id="MetaTitle" rows="3"></b-form-textarea>
                                    <b-form-invalid-feedback v-if="!$v.blogCategory.metaTitle.maxLength">
                                        Không được quá 256 ký tự !
                                    </b-form-invalid-feedback>
                                </b-form-group>

                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="MetaKeywords:"
                                              label-for="MetaKeywords"
                                              :label-cols="4"
                                              label-align="right"
                                              :horizontal="true">
                                    <b-form-textarea v-model="$v.blogCategory.metaKeywords.$model"
                                                     :state="$v.blogCategory.metaKeywords.$model && $v.blogCategory.metaKeywords.$dirty ? !$v.blogCategory.metaKeywords.$error : null"
                                                     class="col-6" id="MetaKeywords" rows="3"></b-form-textarea>
                                    <b-form-invalid-feedback v-if="!$v.blogCategory.metaKeywords.maxLength">
                                        Không được quá 256 ký tự !
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="MetaDescriptions:"
                                              label-for="MetaDescriptions"
                                              :label-cols="4"
                                              label-align="right"
                                              :horizontal="true">
                                    <b-form-textarea v-model="$v.blogCategory.metaDescriptions.$model"
                                                     :state=" $v.blogCategory.metaDescriptions.$model && $v.blogCategory.metaDescriptions.$dirty ? !$v.blogCategory.metaDescriptions.$error : null"
                                                     class="col-6" id="MetaDescriptions" rows="3"></b-form-textarea>
                                    <b-form-invalid-feedback v-if="!$v.blogCategory.metaDescriptions.maxLength">
                                        Không được quá 256 ký tự !
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="Số thứ tự hiển thị:"
                                              label-align="right"
                                              label-for="description"
                                              :label-cols="4"
                                              :horizontal="true">
                                    <b-form-input type="number"
                                                  class="col-6"
                                                  v-model="blogCategory.displayOrder">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="Trạng thái:"
                                              label-align="right"
                                              label-for="status"
                                              :label-cols="4"
                                              :horizontal="true">
                                    <b-form-checkbox id="status" v-model="blogCategory.status" class="col-6 col-form-label"></b-form-checkbox>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="" :label-cols="4">
                                    <b-button v-if="authorize(['ManageBlogCategory'])" type="submit" variant="primary">Ghi lại</b-button>
                                    <b-button type="button" variant="secondary" @click="cancel">Hủy</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { validationMixin } from 'vuelidate'
    import { authorizationMixin } from '@/shared/mixins'
    import { required, sameAs, minLength, maxLength, helpers } from 'vuelidate/lib/validators'

    export default {
        name: 'CreateGroupCategory',
        mixins: [validationMixin, authorizationMixin],
        data() {
            return {
                codeUnique: 'ok',
                blogCategory: {
                    name: null,
                    seoTitle:null,
                    displayOrder:null,
                    metaTitle: null,
                    metaKeywords: null,
                    metaDescriptions: null,
                    status: false

                },
                editing: false
            }
        },
        computed: {
           
        },
        validations: {
            blogCategory: {
                name: {
                    required,
                    maxLength: maxLength(128)
                },
                metaTitle: {
                    maxLength: maxLength(256)
                },
                metaKeywords: {
                    maxLength: maxLength(256)
                },
                metaDescriptions: {
                    maxLength: maxLength(256)
                },
                seoTitle: {
                    maxLength: maxLength(256)
                },
            },
        },
        watch: {
            //'blogCategory.code'(newVal) {
            //    this.checkExistCode(newVal);
            //}
        },
        created() {
        },
        methods: {
            cancel() {
                this.$router.push({ path: '/master-data/blog-categories/list' });
            },
            save() {
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    var vm = this;
                    this.$services.post('master-data/blog-categories', this.blogCategory).done((id) => {
                        vm.$toastr.s('Tạo mới thể loại bài viết thành công');
                        vm.cancel();
                    });
                }
            },
            //checkExistCode(newVal) {
            //    if (newVal) {
            //        //var vm = this;
            //        //this.$services.get(`master-data/existing-unit-types-code/${newVal}/${this.blogCategory.id || null}`).done(returnData => {
            //        //    if (!returnData) {
            //        //        this.codeUnique = "required";
            //        //    }
            //        //    else {
            //        //        this.codeUnique = "";
            //        //    }
            //        //});
            //    }
            //    else {
            //        this.codeUnique = "required";
            //    }
            //}
        }
    }
</script>
<style scoped>
</style>
